export interface SP1Proof {
  proof: string;
  version: string;
}

export interface SP1Vk {
  vk: string;
}

export interface SP1Pubs {
  pubs: string;
}
